import React from 'react';

const ErrorSVG = () => (
  <svg width="112" height="108" viewBox="0 0 112 108" fill="none" xmlns="http://www.w3.org/2000/svg" role="img">
    <title>Error</title>
    <g clipPath="url(#clip0_11525_2342)">
      <path
        d="M49.0619 65.3652L48.8046 65.4089C45.4779 68.056 42.9328 71.5559 41.4408 75.5354C39.9488 79.5148 39.566 83.8243 40.3331 88.0042C41.1002 92.1841 42.9886 96.0775 45.7966 99.2687C48.6046 102.46 52.227 104.83 56.2772 106.125L49.0619 65.3652Z"
        fill="#222325"
      />
      <path
        d="M86.7645 81.1983C86.2782 76.7709 84.5411 72.5734 81.7562 69.0961C78.9713 65.6187 75.2536 63.0053 71.0376 61.561L78.8646 101.418C81.715 98.9337 83.922 95.7976 85.2975 92.2769C86.6731 88.7562 87.1764 84.9553 86.7645 81.1983Z"
        fill="#222325"
      />
      <path d="M53.5923 14.1348L46.7412 0.218384" stroke="#222325" strokeWidth="1.5" strokeLinejoin="bevel" />
      <path d="M64.0747 14.1153L72.2077 0" stroke="#222325" strokeWidth="1.5" strokeLinejoin="bevel" />
      <path d="M72.873 16.3716L87.7066 10.3936" stroke="#222325" strokeWidth="1.5" strokeLinejoin="bevel" />
      <path
        d="M55.3296 47.1934L26.2598 38.5952L28.8672 29.7834L51.7122 36.5426"
        stroke="#222325"
        strokeWidth="1.5"
        strokeLinejoin="bevel"
      />
      <path d="M60.0104 48.5812L57.8691 47.9456" stroke="#222325" strokeWidth="1.5" strokeLinejoin="bevel" />
      <path
        d="M69.7028 41.8608L84.6383 46.2812L82.026 55.093L64.5269 49.9156"
        stroke="#222325"
        strokeWidth="1.5"
        strokeLinejoin="bevel"
      />
      <path
        d="M4.15317 20.8503L17.2047 24.7079L13.7136 36.5087L0.657227 32.6269C1.09241 36.1353 2.72325 39.3869 5.27547 41.8349C7.82769 44.2829 11.1456 45.7779 14.6712 46.0685C18.1968 46.3592 21.715 45.4278 24.6341 43.4308C27.5533 41.4339 29.6953 38.4933 30.6999 35.1036C31.7045 31.7139 31.5104 28.0818 30.1503 24.8183C28.7902 21.5548 26.347 18.8588 23.2317 17.1839C20.1164 15.5089 16.5189 14.9573 13.0443 15.6214C9.56976 16.2856 6.43002 18.1252 4.15317 20.8309V20.8503Z"
        fill="#1DBF73"
      />
      <path
        d="M107.847 64.3559L94.795 60.4741L98.2861 48.6734L111.343 52.5552C110.906 49.0472 109.275 45.7962 106.722 43.3489C104.17 40.9016 100.852 39.4074 97.3261 39.1175C93.8007 38.8275 90.2828 39.7596 87.3642 41.7569C84.4455 43.7541 82.3041 46.6948 81.2999 50.0844C80.2957 53.474 80.4901 57.1058 81.8504 60.369C83.2106 63.6322 85.6538 66.3279 88.769 68.0026C91.8842 69.6774 95.4814 70.229 98.9558 69.5649C102.43 68.9008 105.57 67.0613 107.847 64.3559Z"
        fill="#1DBF73"
      />
      <path
        d="M54.733 101.418L47.1293 54.4282C47.1293 54.4282 39.3169 49.4012 35.9909 46.2958C32.6649 43.1903 33.8642 40.8467 36.1122 41.5115L47.5906 44.9081"
        stroke="#222325"
        strokeWidth="1.5"
        strokeLinejoin="bevel"
      />
      <path d="M69.3428 51.1044L78.3449 96.9683" stroke="#222325" strokeWidth="1.5" strokeLinejoin="bevel" />
      <path
        d="M59.0492 44.0153C59.3745 46.7326 59.996 50.0175 61.7537 50.9007C63.5114 51.7838 65.0312 49.4983 65.002 47.4798C64.9729 45.4612 63.5454 32.0495 62.1616 29.3371C61.0934 27.2603 59.7338 27.5466 58.6073 28.1143C56.2621 29.2789 57.3595 32.6512 57.3595 32.6512"
        stroke="#222325"
        strokeWidth="1.5"
        strokeLinejoin="bevel"
      />
      <path
        d="M64.808 44.8304C65.3809 46.6015 66.0316 48.6444 67.362 48.5522C68.974 48.4406 69.8819 46.1939 69.4984 40.1577C69.3624 37.9644 68.7749 30.9966 66.2646 31.0742C62.8415 31.1761 63.5019 34.7716 63.5019 34.7716"
        stroke="#222325"
        strokeWidth="1.5"
        strokeLinejoin="bevel"
      />
      <path
        d="M55.0487 27.3718C56.8841 28.284 57.3211 32.4279 58.3795 38.3331C59.438 44.2384 59.3506 47.6787 57.3696 48.0377C55.1652 48.4308 53.9708 45.6503 52.786 41.293C52.0189 38.5029 51.3634 34.5338 50.6011 30.9722"
        stroke="#222325"
        strokeWidth="1.5"
        strokeLinejoin="bevel"
      />
      <path
        d="M45.7065 34.7667C47.0175 30.6568 48.6198 27.7843 51.3098 27.1243C53.7375 26.5275 55.2961 26.8866 56.2478 28.8372"
        stroke="#222325"
        strokeWidth="1.5"
        strokeLinejoin="bevel"
      />
      <path
        d="M51.9165 81.4894L74.1886 77.5203L78.8838 101.418C78.8838 101.418 73.4166 106.115 67.2307 107.071C59.8115 108.221 56.2767 106.1 56.2767 106.1L51.9165 81.4894Z"
        fill="#1DBF73"
      />
    </g>
    <defs>
      <clipPath id="clip0_11525_2342">
        <rect width="110.685" height="107.412" fill="white" transform="translate(0.657227)" />
      </clipPath>
    </defs>
  </svg>
);

export default ErrorSVG;
